import { actionNamespace, SUBSCRIBE_ACTIONS, UNSUBSCRIBE_ACTIONS } from 'utils/reduxActionWatch/actionCreators';

// helper function to convert listners object to acceptable object
export const formatListenerObj = (listenersObj = {}) => {
    const formated = {};
    Object.entries(listenersObj).forEach(([action, listener]) => {
        formated[action] = listener instanceof Array ? listener : [listener];
    });

    return formated;
};

export default (state = {}, { type, listenersObj }) => {
    // ignore if action object is not relievent.
    if (!new RegExp(actionNamespace).test(type) || typeof listenersObj !== 'object') {
        return state;
    }

    // clone the state
    const newState = Object.assign({}, state);
    // parse the listenersObj
    const formattedListenerObj = formatListenerObj(listenersObj);

    // Check for subcribe or un-subscribe action
    switch (type) {
        case SUBSCRIBE_ACTIONS: {
            // Add listners
            Object.entries(formattedListenerObj).forEach(([actionType, listeners]) => {
                newState[actionType] = newState[actionType] ? newState[actionType].concat(listeners) : listeners;
            });

            return newState;
        }
        case UNSUBSCRIBE_ACTIONS: {
            // remove listeners
            Object.entries(formattedListenerObj).forEach(([actionType, listeners]) => {
                if (!newState[actionType]) {
                    return;
                }

                listeners.forEach(listener => {
                    const index = newState[actionType].indexOf(listener);
                    newState[actionType].splice(index, 1);
                });
            });

            return newState;
        }
        default: {
            return state;
        }
    }
};
